<template >
  <Modal v-bind="$attrs" @cancel="$emit('cancel')" @confirm="onConfirm">
    <div style="margin-bottom: 10px" v-for="acc in accountList" :key="acc.id">
      <el-radio v-model="accountId" :label="acc.id">{{ acc.name }}</el-radio>
    </div>
  </Modal>
</template>
<script>
import Modal from './modal.vue'
export default {
  components: { Modal },
  inject: ['parentInstance'],
  data() {
    return {
      accountId: ''
    }
  },
  computed: {
    accountList() {
      return this.parentInstance.adAccounts
    }
  },
  methods: {
    onConfirm() {
      const account = this.accountList.find((acc) => acc.id === this.accountId)
      this.$emit('confirm', account)

      this.accountId = ''
    }
  }
}
</script>
